import React from 'react';
import { Love } from './pages/Penelope';
export function App() {
  return <Love data-id="element-0" />;
}